<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<div class="container">
					<div class="mb-3">
						<div class="row g-2">
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="filters.date_from"
									[(ngModel)]="filters.date_range[0]"
									id="filters.date_from"
								/>
								<label for="filters.date_from" class="form-label">Od</label>
							</div>
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="filters.date_to"
									[(ngModel)]="filters.date_range[1]"
									id="filters.date_to"
								/>
								<label for="filters.date_to" class="form-label">Do</label>
							</div>
						</div>
					</div>
					<div class="mb-3">
						<ng-select
							id="location"
							name="location"
							[(ngModel)]="filters.location"
							[multiple]="true"
							[closeOnSelect]="false"
							placeholder="Lokalizacje"
						>
							<ng-option *ngFor="let item of locations" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div class="mb-3">
						<ng-select
							id="groupOffer"
							name="groupOffer"
							[(ngModel)]="filters.group_offer"
							[multiple]="true"
							[closeOnSelect]="false"
							placeholder="Grupy ofert"
						>
							<ng-option *ngFor="let item of groupOffers" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div class="mb-3">
						<ng-select
							id="products"
							name="products"
							[(ngModel)]="filters.product"
							[multiple]="true"
							[closeOnSelect]="false"
							placeholder="Produkty"
						>
							<ng-option *ngFor="let item of products" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div class="form-floating mb-3">
						<mat-form-field class="w-100">
							<mat-label>Ilość noclegów</mat-label>
							<input type="number" matInput min="0" name="nights_stay" [(ngModel)]="nightsStay" />
						</mat-form-field>
					</div>

					<div class="form-floating mb-3">
						<ng-select
							id="stop_sale"
							name="stop_sale"
							[(ngModel)]="filters.stop_sale"
							placeholder="Stop Sale"
						>
							<ng-option value="">(wszystkie)</ng-option>
							<ng-option [value]="item.value" *ngFor="let item of yesno">
								{{ item.name }}
							</ng-option>
						</ng-select>
					</div>
					<div class="form-floating mb-3">
						<ng-select
							id="transport_kind"
							name="transport_kind"
							[(ngModel)]="filters.transport_kind"
							placeholder="Rodzaj transportu"
						>
							<ng-option value="">(wszystkie)</ng-option>
							<ng-option [value]="OfferTermTransport.COACH"> Autokar </ng-option>
							<ng-option [value]="OfferTermTransport.PLANE"> Samolot </ng-option>
						</ng-select>
					</div>
					<div class="form-floating mb-3">
						<ng-select id="www" name="www" [(ngModel)]="filters.www" placeholder="WWW">
							<ng-option value="">(wszystkie)</ng-option>
							<ng-option [value]="item.value" *ngFor="let item of yesno">
								{{ item.name }}
							</ng-option>
						</ng-select>
					</div>
					<div class="form-floating mb-3">
						<ng-select id="sale" name="sale" [(ngModel)]="filters.sale" placeholder="Sprzedaż">
							<ng-option value="">(wszystkie)</ng-option>
							<ng-option [value]="item.value" *ngFor="let item of yesno">
								{{ item.name }}
							</ng-option>
						</ng-select>
					</div>
					<div class="form-floating mb-3">
						<ng-select id="merlinx" name="merlinx" [(ngModel)]="filters.merlinx" placeholder="MerlinX">
							<ng-option value="">(wszystkie)</ng-option>
							<ng-option [value]="item.value" *ngFor="let item of yesno">
								{{ item.name }}
							</ng-option>
						</ng-select>
					</div>
					<div class="form-floating mb-3">
						<ng-select
							id="promotion"
							name="promotion"
							[(ngModel)]="filters.promotion"
							placeholder="Promowany"
						>
							<ng-option value="">(wszystkie)</ng-option>
							<ng-option [value]="item.value" *ngFor="let item of yesno">
								{{ item.name }}
							</ng-option>
						</ng-select>
					</div>
					<div class="form-floating mb-3">
						<ng-select id="archived" name="archived" [(ngModel)]="filters.archived" placeholder="Archiwum">
							<ng-option value="">(wszystkie)</ng-option>
							<ng-option [value]="item.value" *ngFor="let item of yesno">
								{{ item.name }}
							</ng-option>
						</ng-select>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="row row-full">
					<div class="row">
						<div class="col-sm-7 text-start">
							<button type="button" class="btn btn-danger me-1" (click)="filtersClear()">Wyczyść</button>
							<button type="button" class="btn btn-success" (click)="filtersDefault()">Domyślne</button>
						</div>
						<div class="col-sm-5 text-end">
							<button type="button" class="btn btn-primary me-1" (click)="filtersSave()">Pokaż</button>
							<button
								type="button"
								class="btn btn-secondary"
								(click)="filtersClose()"
								data-bs-dismiss="modal"
							>
								Anuluj
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
